import type { IPascoRepository, SearchPascoResult } from "@src/domain/pascos/repository/pasco_repository";
import type { PascoListItemDTO } from "../dto";
import { PascoDtoMapper } from "../mappers/pasco-dto.mapper";

/**
 * Use Case: Get Pending Review PASCOs
 * Retrieves PASCOs that are approved but not yet reviewed
 */
export class GetPendingReviewPascosUseCase {
    constructor(private readonly pascoRepository: IPascoRepository) { }

    async execute(params?: {
        q?: string;
        university_id?: string;
        semester?: string;
        academic_year?: string;
        skip?: number;
        limit?: number;
    }): Promise<{ pascos: PascoListItemDTO[]; total: number; hasMore: boolean }> {
        const result: SearchPascoResult = await this.pascoRepository.getPendingReviewPascos(params);

        return {
            pascos: PascoDtoMapper.toListItemDTOArray(result.pascos),
            total: result.total,
            hasMore: result.hasMore,
        };
    }
}